import firebase from "../../config/firebase";

/**
 * ID token do usuário logado, para o header `Authorization` da API.
 *
 * O interceptor lia `localStorage.getItem("token")` e não existia um único `setItem("token")` no
 * repositório — o header nunca saía, e por isso nenhuma rota do backend podia exigir token sem
 * derrubar o painel.
 *
 * Vem do SDK e não de um cache nosso: `getIdToken()` devolve o token em memória enquanto ele é
 * válido e renova sozinho perto da expiração de 1 h. Guardar cópia aqui só criaria um segundo lugar
 * para o token vencer. Fora do `localStorage` também de propósito: token que sobrevive ao logout é
 * token que vaza.
 *
 * Nulo enquanto ninguém está logado. Um F5 continua caindo no login, como sempre caiu — a sessão do
 * painel vive só na memória do Redux, e isso não muda aqui.
 */
export async function tokenDaApi() {
  const usuario = firebase.auth().currentUser;
  if (!usuario) return null;

  try {
    return await usuario.getIdToken();
  } catch (erro) {
    // Sem sessão válida a requisição segue sem header e o backend responde 401, que é a resposta
    // certa. Derrubar a chamada aqui esconderia a causa.
    console.error("Não foi possível obter o token da sessão:", erro?.message || erro);
    return null;
  }
}
